import { render, staticRenderFns } from "./DocumentData.vue?vue&type=template&id=271d66b1&scoped=true&"
import script from "./DocumentData.vue?vue&type=script&lang=ts&"
export * from "./DocumentData.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentData.vue?vue&type=style&index=0&id=271d66b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d66b1",
  null
  
)

export default component.exports